<div class="container-full" style="margin-top:10px;">
    <app-header-title-lot-data style="margin-top:10px;"
        [title]="'Automated Tasks Report'"
        [lotNumber]="_appGeneralState.currentLotNumber"
        [lotName]="_appGeneralState.currentLotName"
    ></app-header-title-lot-data>
    
    <mat-card style="margin-top:30px;margin-left:10px;margin-right:0px;width:99%;height:90%;min-height: 700px;">
        <mat-card-header>
        
        </mat-card-header>    
        <mat-card-content>
                <form 
                (ngSubmit)="onSubmitAutomatedTasksReport()" 
                novalidate
                [formGroup]="recurringTaskReportForm" 
                style="margin-top:20px;">
            <div class="row" style="width:100%;">
                <div class="col-6">
                    <mat-form-field appearance="fill" style="width:100%;color:gray">
                        <mat-label>Task Name:</mat-label>
                        <mat-select formControlName="taskType">
                            <mat-option value="">Select Task Type</mat-option>
                            <mat-option value="all">All Tasks</mat-option>
                            <mat-option value="spaceaccount">Bad SpaceAccount(s)</mat-option>
                            <mat-option value="monthlylpr">Monthly LPR Vehicle Update</mat-option>
                        </mat-select>
                      </mat-form-field>
                </div>
                <div class="col-3">
                    <button type="submit" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;" [disabled]="!recurringTaskReportForm.valid">View Report</button>
                </div>
            </div>
        </form>



<ng-container *ngIf="this.reportTaskSummary.length > 0">
    <div style="margin-top:30px;"></div>
    <igx-grid #gridAgingReport id="reportTaskSummary" [igxPreventDocumentScroll]="true" [data]="reportTaskSummary" [height]="'720px'" [width]="'100%'" [autoGenerate]="false"
    [primaryKey]="'taskId'" [cellSelection]="'none'" [rowEditable]="false">

    <igx-column field="taskName" header="Task Name"  width="350px" [sortable]="true"></igx-column>
    <igx-column field="executionStartDateTime" header="Start"  width="205px" [sortable]="true">
        <ng-template igxCell let-value let-cell="cell">
            <div class="cell__inner">
                {{ value | date : 'medium'}}
            </div>
        </ng-template> 
    </igx-column>
    <igx-column field="executionFinishDateTime" header="Finish"  width="205px" [sortable]="true">
        <ng-template igxCell let-value let-cell="cell">
            <div class="cell__inner">
                {{ value | date : 'medium'}}
            </div>
        </ng-template> 
    </igx-column>
    <igx-column field="statusText" header="Status"  width="205px" [sortable]="true"></igx-column>
    <igx-column field="comments" header="Comments"  width="800px" [sortable]="true"></igx-column>
    <!-- <ng-template igxCell let-value let-cell="cell">
        <div class="cell__inner">
            
                @if(value == 'Totals')
                {
                    <div style="display:inline-block;text-align: right;width:125px;">
                    <strong>{{value}}:</strong>
                    </div>
                }
                @else {
                    <a href="https://{{urlDomain}}/Invoice/ReturnPdf/{{_appGeneralState.currentLotNumber}}/{{value}}" target="_blank">
                        {{value}}
                    </a>
                }
                
        </div>
    </ng-template> -->


<igx-grid-toolbar>
<igx-grid-toolbar-actions>
<igx-grid-toolbar-pinning></igx-grid-toolbar-pinning>
<igx-grid-toolbar-hiding></igx-grid-toolbar-hiding>
<igx-grid-toolbar-exporter></igx-grid-toolbar-exporter>
</igx-grid-toolbar-actions>
</igx-grid-toolbar>

<!-- <igx-action-strip #actionStrip1>
    <igx-grid-pinning-actions></igx-grid-pinning-actions>
    <igx-grid-editing-actions></igx-grid-editing-actions>
</igx-action-strip> -->

</igx-grid>


</ng-container>

</mat-card-content>
<mat-card-actions style="margin-top:20px;">
    
</mat-card-actions>

</mat-card>                                                                             

</div>
